import { useFormikContext } from "formik";
import { DisplayFormErrors, InputField, VerticalForm, } from "melco-shared-logic";
import { Space } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { EditEmailConfirmButton } from "./EditEmailConfirmButton";

const Right = styled(Space)`
display:flex;
align-items:flex-end;
flex-direction: column;
`;

type DisplayEditEmailFormProps = {

}



export const DisplayEditEmailForm: React.FC<DisplayEditEmailFormProps> = ({

}) => {
    const { t } = useTranslation();
    const { setFieldValue, values } = useFormikContext();
    const [formFields, setFields] = useState<any>(values);


    useEffect(() => {
        setFields(values);
    }, [values])

    return (
        <>

            <div>

                <Right direction="vertical" size="small">
                    <EditEmailConfirmButton />
                </Right>
                <VerticalForm>
                    <DisplayFormErrors />

                    <InputField
                        name="new_email_address"
                        label={t("licenses.basic.detail.editemail.form.emailaddress")}

                    />




                </VerticalForm>
            </div>
        </>

    );
};
